module.exports = __webpack_public_path__ + "img/lock-room.4a728b0f.svg";